@use "variables" as *;

.imageDiv {
  width: 40px;
  border-style: solid;
  border-width: 2px;
  border-color: black;
}

.name {
  font-size: $fontSize-m;
  font-weight: normal;
}
